import { createContext, ReactNode, useMemo, useReducer } from "react";
import teamMateSlice, { initialState } from "./teamMateSlice";
import { TeamMateContextProps } from "./types";

export const TeamMateContext = createContext<TeamMateContextProps>({
  state: initialState,
  dispatch: () => null,
});

const TeamMateProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const [state, dispatch] = useReducer(teamMateSlice.reducer, teamMateSlice.getInitialState());

  const values = useMemo(
    () => ({
      state,
      dispatch,
    }),
    [state, dispatch]
  );

  return <TeamMateContext.Provider value={values}>{children}</TeamMateContext.Provider>;
};

export default TeamMateProvider;
